import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { LanguageSwitcher } from "@/components/LanguageSwitcher";

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer data-testid="footer" className="bg-ink text-sand">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 border-b border-sand/15 pb-12">
          <div>
            <p className="font-serif text-4xl md:text-5xl">
              Luz de <span className="italic text-[#D5C0A1]">Cádiz</span>
            </p>
            <p className="mt-4 text-sand/60 text-sm font-light max-w-xs">{t("footer.tagline")}</p>
          </div>
          <LanguageSwitcher dark />
        </div>
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 pt-8 text-[11px] uppercase tracking-[0.2em] text-sand/50">
          <span>© {new Date().getFullYear()} Luz de Cádiz · {t("footer.rights")}</span>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
            <Link data-testid="footer-legal-notice" to="/legal/aviso-legal" className="hover:text-[#D5C0A1] transition-colors">{t("legal.notice")}</Link>
            <Link data-testid="footer-legal-privacy" to="/legal/privacidad" className="hover:text-[#D5C0A1] transition-colors">{t("legal.privacy")}</Link>
            <Link data-testid="footer-legal-cookies" to="/legal/cookies" className="hover:text-[#D5C0A1] transition-colors">{t("legal.cookies")}</Link>
            <Link data-testid="footer-legal-cancel" to="/legal/cancelacion" className="hover:text-[#D5C0A1] transition-colors">{t("legal.cancel")}</Link>
            <Link data-testid="footer-legal-terms" to="/legal/condiciones" className="hover:text-[#D5C0A1] transition-colors">{t("legal.terms")}</Link>
          </div>
        </div>
        <p className="pt-6 text-[11px] leading-relaxed text-sand/35 normal-case tracking-normal">{t("footer.seo")}</p>
      </div>
    </footer>
  );
};
